import { useSuspenseQuery } from "@tanstack/react-query"
import { createFileRoute, Link } from "@tanstack/react-router"

import { PageContent } from "@/components/common/page-content"
import { PageHeader } from "@/components/common/page-header"
import { Button } from "@/components/ui/button"
import { IndividualPersonalDetails } from "@/features/individuals/components/individual-personal-details"
import { countryQueries } from "@/queries/countries"
import { individualQueries } from "@/queries/individuals"

export const Route = createFileRoute(
  "/$organisation/_authenticated/_organisation/individuals/$individualId/record/"
)({
  staticData: { attention: "individual.details" },
  loader: ({ context }) =>
    context.queryClient.ensureQueryData(countryQueries.list()),
  component: IndividualRecordPage,
})

function IndividualRecordPage() {
  const { individualId } = Route.useParams()
  const { data: individual } = useSuspenseQuery(
    individualQueries.detail(individualId)
  )

  return (
    <>
      <PageHeader
        title="Personal details"
        actions={
          <Button
            nativeButton={false}
            render={
              <Link
                from="/$organisation"
                to="/$organisation/individuals/$individualId/record/edit"
                params={{ individualId }}
              >
                Edit
              </Link>
            }
          />
        }
      />
      <PageContent>
        <IndividualPersonalDetails individual={individual} />
      </PageContent>
    </>
  )
}
